var scope_0 = require('/Users/joeloliveira/Development/WWW/Projects/notificare-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0d8284ee5f0b8836bc778236cc63baac.js').default;
var scope_1 = require('/Users/joeloliveira/Development/WWW/Projects/notificare-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6c382c8a21e6468f124aa9e654571f6b.js').default;
var scope_2 = require('/Users/joeloliveira/Development/WWW/Projects/notificare-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    